
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// Components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// Types
import { DispatcherSectorT } from '@/core/types/dispatchers_sector.types'
import { UserT } from '@/core/types/users.types'

// Realisations
import { dispatchers_sectors } from '@/core/realisations/dispatchers_sectors.realisation'

// Classes
import { DataState } from '@/core/classes/DataState.class'

// Validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        Modal,
        TheSelect
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object as PropType<UserT>,
            required: true
        }
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const state = reactive({
            sectors: [] as number[]
        })

        const state_form$ = useVuelidate({
            sectors: { required }
        }, state)

        const data_state = reactive({
            dispatchers_sectors: new DataState<DispatcherSectorT>({})
        })

        const loadDispatchersSectors = async () => {
            try {
                data_state.dispatchers_sectors.is_loading = true

                const response = await dispatchers_sectors.getList()
                data_state.dispatchers_sectors.list = response.data

                data_state.dispatchers_sectors.pagination.total_pages = 1

                data_state.dispatchers_sectors.is_failed = false
                data_state.dispatchers_sectors.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.dispatchers_sectors.failure.catchError(error)

                if (!data_state.dispatchers_sectors.failure.error_state.is_cancel) {
                    data_state.dispatchers_sectors.is_failed = true
                }
            } finally {
                if (!data_state.dispatchers_sectors.failure.error_state.is_cancel) {
                    data_state.dispatchers_sectors.is_loading = false
                }
            }
        }

        const emitSubmit = () => {
            if (props.loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', { id: props.user.id, sectors: state.sectors })
        }

        const emitCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        onBeforeMount(loadDispatchersSectors)

        return {
            state,
            state_form$,
            data_state,
            emitSubmit,
            emitCancel,
            loadDispatchersSectors
        }
    },
})
